<template>
  <div class="home">
    <div
      v-for="element in elements"
      :key="element.id"
    >
      <WarningList
        v-if="element.type === 'WarningList' && element.active"
      />
      <QuickAccess
        v-if="element.type === 'QuickAccess' && element.active"
      />
      <CalendarShortList
        v-if="element.type === 'CalendarShortList' && element.active"
      />
      <ArticleShortList
        v-if="element.type === 'ArticleShortList' && element.active"
        :amount="5"
      />
    </div>
  </div>
</template>

<script>

import ArticleShortList from '../components/Article/ArticleShortList'
import WarningList from '../components/Warning/WarningList'
import CalendarShortList from '@/components/Calendar/CalendarShortList'
import QuickAccess from '@/components/QuickAccess/QuickAccess'

export default {
  name: 'Home',
  components: {
    QuickAccess,
    CalendarShortList,
    WarningList,
    ArticleShortList
  },
  data () {
    return {
      elements:
        [
          {
            id: 1,
            position: 1,
            type: 'WarningList',
            active: true,
            options: {}
          },
          {
            id: 2,
            position: 2,
            type: 'QuickAccess',
            active: true,
            options: {}
          },
          {
            id: 3,
            position: 3,
            type: 'ArticleShortList',
            active: true,
            options: {}
          },
          {
            id: 4,
            position: 4,
            type: 'CalendarShortList',
            active: true,
            options: {}
          }
        ]
    }
  }
}
</script>

<style scoped>
.home div {
  margin: 16px 0;
}
</style>
